import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CreateNewInvoiceInfo {
    invoiceId: number;
    siteName: string;
    participantId: number;
    vendor: string;
    vendorNumber: string;
    projectNumber: string;
    invoiceNumberValue: string;
    confirmInvoiceNumberValue: string;
    subsidyAmount: any;
    fee: any;
    totalAmount: string;
    calculatedFeeAmount: string;
    invoiceAmountRaw: any;
    maskedInvoiceAmount: any;
    confirmInvoiceAmountRaw: any;
    maskedConfirmInvoiceAmount: any;
    descriptionValue: any;
    invoiceDate: string;
    dueDate: string;
    paymentMethod: { id: number; name: string; value: string } | null;
    isInitialApprover: boolean;
    projectManagerValue: string
    businessManagerValue: string;
    projectApproverValue: string;
    ccListValue: string[];
    selectedInvoiceFiles: any[];
    invoiceTransactionHistory: any[];
    invoiceApprover: any[];
    sourceSystem: string;
    version: number;
    wfJsonFileName: string;
    notificationList: string;
    projectManagerMailId: string;
    businessMangerMailId: string;
    projectApproverMailId: string;
    parentInvoiceNumber: string;
    clientId: number;
    paBaComments: string;
    parentInvoiceId: number;
}

const initialState: CreateNewInvoiceInfo = {
    invoiceId: 0,
    siteName: "",
    vendorNumber: "",
    participantId: 0,
    vendor: "",
    projectNumber: "",
    invoiceNumberValue: "",
    confirmInvoiceNumberValue: "",
    subsidyAmount: "",
    fee: "",
    totalAmount: "",
    calculatedFeeAmount: "",
    invoiceAmountRaw: "",
    maskedInvoiceAmount: "",
    confirmInvoiceAmountRaw: "",
    maskedConfirmInvoiceAmount: "",
    descriptionValue: "",
    invoiceDate: "",
    dueDate: "",
    paymentMethod: null,
    isInitialApprover: true,
    projectManagerValue: "",
    businessManagerValue: "",
    projectApproverValue: "",
    ccListValue: [],
    selectedInvoiceFiles: [],
    invoiceTransactionHistory: [],
    invoiceApprover: [],
    sourceSystem: "",
    version: 0,
    wfJsonFileName: '',
    notificationList: '',
    projectManagerMailId: '',
    businessMangerMailId:"",
    projectApproverMailId:"",
    parentInvoiceNumber:"",
    clientId:0,
    paBaComments:"",
    parentInvoiceId:0
};

const CreateNewInvoiceSlice = createSlice({
    name: "newInvoice",
    initialState,
    reducers: {
        setCreateNewInvoice: (
            state,
            action: PayloadAction<Partial<CreateNewInvoiceInfo>>
        ) => {
            return { ...state, ...action.payload };
        },
        removeNewInvoice: () => initialState,
    },
});

export const { setCreateNewInvoice, removeNewInvoice } =
    CreateNewInvoiceSlice.actions;
export default CreateNewInvoiceSlice.reducer;
